import ApiBase from 'app/services/api/entities/Base'

function* checkAddNewChildPermissions() {
  return yield ApiBase.privateGet('/v1/contract_version/permissions/add_new_child/', {})
}

function* checkConsentType() {
  return yield ApiBase.privateGet('/v1/contract_version/consent_type/add_new_child/', {})
}

function* getDocumentUrl(documentType) {
  return yield ApiBase.privateGet(`/v1/contract_version/documents/${documentType}/pdf_url/`, {})
}

function* acceptNetworkContract(documentType) {
  return yield ApiBase.privatePost(`/v1/contract_version/documents/${documentType}/agree/`, {})
}

export default {
  checkAddNewChildPermissions,
  checkConsentType,
  getDocumentUrl,
  acceptNetworkContract,
}
